// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__TmGfB","modalFooterButton":"ModalNotes_modalFooterButton__2Ickc"};